import profileActions from './actions';

const INITIAL_DATA = {
  data: null,
  loading: false,
  loaded:false,
  error: null,
  empresas:[],
  notificaciones: [],
};
export default function profileReducer(state = INITIAL_DATA, action) {
  switch (action.type) {
    case profileActions.FETCH_PROFILE_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
        loaded: true,
      };
    case profileActions.FETCH_PROFILE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case profileActions.SET_PROFILE_DATA:
      return {
        ...state,
        loading: false,
        data: action.profile,
      };
    case profileActions.PROFILE_EMPRESAS:
      return {
        ...state,
        empresas:action.empresas,
      }
    case profileActions.SET_NOTIFICACIONES:
      return {
        ...state,
        notificaciones:action.payload,
      }
    default:
      return state;
  }
}
